import Vue from "vue";
import Router from "vue-router";
import {
  setRem,
  clearLocalStorage,
  getItem,
  setItem,
  changeTitle,
} from "@/utils/";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "login",
      component: (resolve) => require(["@/views/Login"], resolve),
      meta: {
        requiresAuth: false,
        title: "登录",
        ownTitle: true,
      },
    },
    {
      path: "/accounthome",
      name: "accounthome",
      component: (resolve) => require(["@/views/AccountHome"], resolve),
      children: [
        {
          path: "/",
          redirect: "/scan",
        },
        {
          path: "/scan",
          component: (resolve) => require(["@/views/Scan"], resolve),
          meta: {
            requiresAuth: true,
            ownTitle: false,
          },
        },
        {
          path: "/account",
          component: (resolve) => require(["@/views/Account"], resolve),
          meta: {
            requiresAuth: true,
            ownTitle: false,
          },
        },
      ],
      meta: {
        requiresAuth: true,
        ownTitle: false,
      },
    },
    {
      path: "/scantips",
      name: "scantips",
      component: (resolve) => require(["@/views/ScanTips"], resolve),
      meta: {
        requiresAuth: true,
        title: "验证指南",
        ownTitle: true,
      },
    },
    // {
    //   path: "/camera",
    //   name: "camera",
    //   component: (resolve) => require(["@/views/Camera"], resolve),
    //   meta: {
    //     requiresAuth: true,
    //     title: "发票拍照上传",
    //     ownTitle: true,
    //   },
    // },
    {
      path: "/invoicemsg",
      name: "invoicemsg",
      component: (resolve) => require(["@/views/InvoiceMsg"], resolve),
      meta: {
        requiresAuth: true,
        title: "发票信息",
        ownTitle: true,
      },
    },
    {
      path: "/invoicemanual",
      name: "invoicemanual",
      component: (resolve) => require(["@/views/InvoiceManual"], resolve),
      meta: {
        requiresAuth: true,
        title: "输入发票",
        ownTitle: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  setRem();
  try {
    if (to.meta.ownTitle) {
      changeTitle(to.meta.title);
    } else {
      let name =
        (getItem("accountLoginUser") &&
          getItem("accountLoginUser").tenantInfo &&
          getItem("accountLoginUser").tenantInfo.tenantName) ||
        "会计端";
      changeTitle(name);
    }
    if (to.path === "/login" && from.path === "/") {
      if (getItem("accountLoginUser")) {
        next({
          path: "/accounthome",
        });
      } else {
        next();
      }
    } else {
      if (to.matched.every((v, i) => v.meta.requiresAuth)) {
        if (getItem("accountLoginUser")) {
          next();
        } else {
          clearLocalStorage();
          next({
            path: "/login",
          });
        }
      } else {
        if (getItem("accountLoginUser")) {
          next({
            path: "/accounthome",
          });
        } else {
          clearLocalStorage();
          next();
        }
      }
    }
  } catch (error) {
    console.log("router error ---->>>> ", error);
    clearLocalStorage();
    next();
    throw new Error(error);
  }
});

export { router };



// WEBPACK FOOTER //
// ./src/router/index.js